var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinEma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 27,
    viewBox: "0 0 18 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 39838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 39826"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 45",
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#1B2466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M9 27L1.20577 13.5L16.7942 13.5L9 27Z",
    fill: "#1B2466"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 46",
    cx: 9,
    cy: 9,
    r: 4,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinEma);
export default __webpack_public_path__ + "static/media/pinEMA.5146f84208972d30405c6084eff64d42.svg";
export { ForwardRef as ReactComponent };